import {
    useGetProjectsQuery,
    useUpdateProjectPositionMutation,
} from "../../features/project/projectApi";
import ProjectCard from "./../ui/ProjectCard";
import { useDrop } from "react-dnd";
import { api } from "../../features/api/api";
import { useDispatch } from "react-redux";
import projectLength from "../../utils/projectLength";

export default function Review() {
    const dispatch = useDispatch();
    // get projects api
    const {
        data: getProjects,
        isLoading,
        isError,
    } = useGetProjectsQuery() || [];
    const [updateProjectPositionApi] = useUpdateProjectPositionMutation();

    let content;
    if (isLoading && !isError)
        content = <p className="text-green-700">Loading...</p>;
    if (!isLoading && isError)
        content = <p className="text-red-700">Something wrong</p>;
    if (!isLoading && !isError && getProjects?.length > 0) {
        content = getProjects
            ?.filter((project) => project.position === "review")
            .map((project) => (
                <ProjectCard key={project.id} project={project} />
            ));
    }
    if (!isLoading && !isError && getProjects?.length === 0) {
        content = <p className="text-red-700">Project is empty!</p>;
    }

    // dnd code
    const [{ isOver }, drop] = useDrop(() => ({
        accept: "PROJECT_STAGE_CHANGE",
        drop: (item, monitor) => ready(item.id),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    const ready = (id) => {
        dispatch(
            api.util.updateQueryData("getProjects", undefined, (draft) => {
                const project = draft.find((project) => project.id === id);
                project.position = "review";
            })
        );
        updateProjectPositionApi({
            id,
            position: "review",
        });
    };
    return (
        <>
            <div className="flex flex-col flex-shrink-0 w-72">
                <div className="flex items-center flex-shrink-0 h-10 px-2">
                    <span className="block text-sm font-semibold">Review</span>
                    <span className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                        {projectLength(getProjects, "review")}
                    </span>
                </div>
                <div
                    className={`flex flex-col pb-2 overflow-auto h-screen px-2  ${
                        isOver && "border-dashed border-spacing-3 border-2"
                    }`}
                    ref={drop}
                >
                    {content}
                </div>
            </div>
        </>
    );
}
